module.exports = __webpack_public_path__ + "img/baker.a56cf8e4.png";